import {
    DialogContent,
    DialogTitle,
    TextField
} from "@mui/material";
import {Dialog2} from "../../../../misc/Dialog2";
import {SmoothActionBar} from "../../../../misc/SmoothActionBar";
import React, {useContext, useState} from "react";
import {api} from "../../../../api/API";
import {Alternative, alternativeLabel} from "../../../../api/QuoteAlternatives";
import {ConfirmContext} from "../../../../misc/Confirm";
import {useAsyncAction} from "nate-react-api-helpers";
import {useSyncedRef} from "../../../../misc/SyncedRef";
import {useAlternative} from "./Alternative";

export function ManageAlternatives(props: {
    value: Alternative;
    onDone(): void;
    onCancel(): void;
}) {
    const [name, setName] = useState(props.value.name);
    const [description, setDescription] = useState(props.value.description);
    const confirm = useContext(ConfirmContext);
    const onDoneRef = useSyncedRef(props.onDone);
    const update = useAsyncAction(async (input) => {
        await api.quoteAlternatives.upsert(input)
        onDoneRef.current();
    }, [])

    const alternative = useAlternative();
    const isCurrent = alternative === props.value.id

    const submit = () => {
        update.callback(Object.assign({}, props.value, {
            name: name,
            description: description,
        }))
    };

    return (
        <Dialog2 open onClose={props.onDone} onEnterPress={submit}>
            <DialogTitle>
                Manage {alternativeLabel(props.value)}
            </DialogTitle>
            <DialogContent>
                <div style={{height: 8}} />
                <TextField fullWidth label="Name" value={name} onChange={e => setName(e.target.value)} />
                <div style={{height: 8}} />
                <TextField
                    fullWidth
                    label="Description"
                    value={description}
                    onChange={e => setDescription(e.target.value)}
                    multiline
                    rows="3"
                />
            </DialogContent>
            <SmoothActionBar
                loading={update.loading}
                destroyLoading={update.loading}
                error={update.error}
                onSubmit={submit}
                onCancel={props.onCancel}
                onDestroy={async () => {
                    const ok = await confirm.confirm("Are you sure you want to archive this?")
                    if(!ok) return;

                    update.callback(Object.assign({}, props.value, {
                        archived: true,
                    }))
                }}
                destroyDisabled={isCurrent}
                destroyName={isCurrent ? "Archive (Can't archive while active)" : "Archive"}
            />
        </Dialog2>
    )
}